import { Action, Login, LoginResult, PuzzleStamp, TeamInfo } from "./types";
import ApiService, { FetchOptions } from "./Utils/fetchUtils";

class AquacoinApi {
    private _service = new ApiService();
    private _login: Login | undefined = undefined;

    constructor() {
        console.log(process.env.NODE_ENV)
        if (process.env.NODE_ENV === "development") {
            this._service.Init('/');
        } else {
            this._service.Init('https://api.aquacoin.cz/');
        }
        if (sessionStorage.getItem("teamId") !== null && sessionStorage.getItem("secret") !== null) {
            this._login = {
                teamId: parseInt(sessionStorage.getItem("teamId")!),
                secret: sessionStorage.getItem("secret")!,
            }
        }
    }

    public get isLoggedIn(): boolean {
        return this._login !== undefined
    }

    public login = (email: string, password: string, onError?: (msg: string) => void) => {
        if (this._login !== undefined)
            throw new Error('You are already logged in');
        this._service.post('/teams/login', { email: email, password: password }, null, {
            success: (res: LoginResult) => {
                if (res.result === "SUCCESS") {
                    sessionStorage.setItem("teamId", res.teamId.toString());
                    sessionStorage.setItem("secret", res.secret.toString());
                    this._login = res;
                    window.location.reload();
                } else if (res.result === "INVALID") {
                    onError && onError("Nesprávný přihlašovací email či heslo.");
                } else {
                    onError && onError("Při přihlášení došlo k chybě.");
                }
            },
            error: onError || (() => { }),
        })
    }

    public logout = () => {
        this._login = undefined;
        sessionStorage.removeItem("teamId");
        sessionStorage.removeItem("secret");
        window.location.reload();
    }

    public puzzles = {
        getList: (fetchOptions?: FetchOptions<PuzzleStamp[]>) => this._service.get('/puzzles/list', {}, fetchOptions),
        getHelp: (puzzleId: number, fetchOptions?: FetchOptions<string>) => {
            if (this._login === undefined)
                throw new Error('You are not logged in');
            this._service.get('/puzzles/help', { puzzleId: puzzleId, secret: this._login.secret, teamId: this._login.teamId }, fetchOptions);
        },
        getInstructions: (puzzleId: number, fetchOptions?: FetchOptions<string>) => {
            if (this._login === undefined)
                throw new Error('You are not logged in');
            this._service.get('/puzzles/instructions', { puzzleId: puzzleId, secret: this._login.secret, teamId: this._login.teamId }, fetchOptions);
        },
        performAction: (puzzleId: number, action: Action, code?: string, fetchOptions?: FetchOptions<{ result: "ERROR" | "INVALID STATE" | "INVALID CODE" | "SUCCESS", team: TeamInfo }>) => {
            if (this._login === undefined)
                throw new Error('You are not logged in');
            if (code === undefined && (action === "solve" || action === "arrive"))
                throw new Error('You must provide a code for "arrive" or "solve" action.');
            this._service.post('/puzzles/action', { action: action, puzzleId: puzzleId, code: code ?? "", secret: this._login.secret, teamId: this._login.teamId }, null, fetchOptions)
        }
    }

    public teams = {
        loadTeamInfo: (fetchOptions?: FetchOptions<TeamInfo>) => {
            if (this._login === undefined)
                throw new Error('You are not logged in');
            this._service.get('/teams/full', { id: this._login.teamId, secret: this._login.secret }, fetchOptions)
        }
    }
}


const api = new AquacoinApi();

export default api;
